import React from 'react';

import {
  TableColumnEditor,
  NumberEditor,
  DraftEditorProps,
} from '../field-widgets';
import { AggregationDraft } from '../../models';

export const LastKEditor = (props: DraftEditorProps<AggregationDraft>) => {
  return [
    <TableColumnEditor
      {...props}
      key="source_time_filed"
      label="source_time_filed"
      tableColumns={props.tableColumns}
    />,
    <TableColumnEditor
      {...props}
      key="source_time_filed"
      label="source_field"
      tableColumns={props.tableColumns}
    />,
    <NumberEditor label="k" {...props} />,
  ];
};
